import Vue from 'vue'
let $ = require('jQuery')

Vue.directive('headerSticky', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    console.log('11111111', el)
    $(document).on('scroll', () => {
      let scrollTop = $(document).scrollTop()
      if (scrollTop >= 38) {
        $(el).addClass('document-scrolled')
      } else {
        $(el).removeClass('document-scrolled')
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/directives/HeaderSticky.js